import api from "./api";

// Clube Recrutei: descontos de parceiros, operados pela New Value.
// Rotas em recrutei-api, ClubController (routes/api-whitelabel/whitelabel.php).
const base = (label) => `api/v1/talent/${label}/user/talent/club`;

function unwrap(response) {
  return response && response.data ? response.data.data : null;
}

export async function fetchClubStatus(label) {
  return unwrap(await api.get(base(label)));
}

export async function activateClub(label) {
  return unwrap(await api.post(`${base(label)}/activate`, { consent: true }));
}

// Devolve o corpo inteiro: { data, meta, filters }.
export async function fetchClubOffers(label, params) {
  const response = await api.get(`${base(label)}/offers`, { params });
  return response.data;
}

// Interesse numa oferta (abriu o detalhe ou quis assinar por ela), para o Admin ver as
// ofertas mais procuradas. Nunca atrapalha a tela: erro aqui é ignorado.
export function trackOfferEvent(label, offerId, kind) {
  if (!offerId) return;
  api.post(`${base(label)}/offers/${offerId}/events`, { kind }).catch(() => {});
}

// { url, club }: o estado volta junto porque, no teste grátis, a primeira ida começa os dias.
export async function openClubAccess(label, offerId) {
  return unwrap(await api.post(`${base(label)}/access`, { offer_id: offerId || null })) || {};
}

export async function deactivateClub(label) {
  return unwrap(await api.delete(base(label)));
}

// Modo assinatura: abre o Checkout da Stripe. O aceite (envio à New Value) vem marcado do paywall.
export async function startClubCheckout(label, offer) {
  const data = unwrap(
    await api.post(`${base(label)}/checkout`, {
      consent: true,
      offer_id: offer ? offer.id : null,
      offer_partner: offer ? offer.partner : null,
    })
  );
  return data && data.checkout_url;
}

// { status: "pending"|"paid"|"failed"|"expired", club: <mesmo formato de fetchClubStatus> }
export async function fetchCheckoutStatus(label, sessionId) {
  return unwrap(await api.get(`${base(label)}/checkout/status`, { params: { session_id: sessionId } }));
}

export async function clubBillingPortal(label) {
  const data = unwrap(await api.post(`${base(label)}/billing-portal`));
  return data && data.url;
}

export function errorReason(error) {
  const data = error && error.response && error.response.data;
  return (data && data.reason) || null;
}

export function errorMessage(error) {
  const data = error && error.response && error.response.data;
  return (data && data.message) || "Não foi possível falar com o Clube Recrutei agora. Tente de novo em alguns minutos.";
}
